<template>
  <div>
    <infos
      :type="5"
      v-if="firstInfo"
      @nextButton="nextInfo"
      @goBack="back"
    ></infos>
    <div class="panel-group" v-if="!firstInfo">
      <div class="panel row">
        <div
          class="col-md-12"
          v-for="(issue, j) in selectedFlight"
          :key="issue.passanger.id"
        >
          <div v-if="!Boolean(issue.passanger.isExtra)">
            <a
              :href="`#book-flight-${j}`"
              class="title-passanger book-flight__panel__heading--selection"
              @click="
                issuanceDetail(issue.passanger.id);
                scrollOnTop();
              "
            >
              {{ selectedFlight[j].flight ? "" : "Selecione o voo para" }}
              {{
                issue.passanger.badgeName
                  ? issue.passanger.badgeName
                  : issue.passanger.guest
              }}
              <span v-if="Boolean(selectedFlight[j].flight)">
                &nbsp;&nbsp;<i class="fa fa-plane"></i>&nbsp;&nbsp; Opção
                {{ selectedFlight[j].flight.group_number }} -
                <strong>{{ selectedFlight[j].flight.city }}</strong> -
                {{ selectedFlight[j].flight.company }}
              </span>
              <i
                :class="{
                  'fa fa-angle-up ml-2': issue.display,
                  'fa fa-angle-down': !issue.display,
                }"
              ></i>
            </a>

            <div
              v-if="issue.display"
              class="book-flight"
              :id="`book-flight-${j}`"
            >
              <div v-for="(flight, i) in flights" :key="`fg${i}`">
                <div class="book-flight__panel" v-if="flight.company && 
                ((flight.group_number === 0 && participantRank === 2) || (flight.group_number !== 0 && participantRank !== 2))">
                  <div class="book-flight__panel__heading">
                    <div class="book-flight__panel__heading--selection">
                      <input
                        type="radio"
                        :id="'selectFlight' + flight.id"
                        @input="$v.whichFlight.$touch()"
                        :value="flight"
                        v-model="selectedFlight[j].flight"
                      />
                      <!-- @click="selectFlightTo(issue.id ,flight.id)" -->
                      <label :for="'selectFlight' + flight.id">
                        <i class="fa fa-plane"></i>&nbsp;&nbsp; Opção
                        {{ flight.group_number }} -
                        <strong>{{ flight.city }}</strong> -
                        {{ flight.company }}
                        <span v-if="flight.count < 11" style="color: #d91e18"
                          >- Vagas restantes: {{ flight.count }}
                        </span>
                      </label>
                    </div>
                    <div v-if="flight.attachment_binary">
                      <img
                        v-bind:src="
                          'data:image/jpeg;base64,' + flight.attachment_binary
                        "
                        width="100%"
                      />
                    </div>
                  </div>
                  <div
                    id="book-flight__panel__body--1"
                    class="book-flight__panel__body in"
                    v-if="flight.display"
                  >
                    <hr />
                    <div class="book-flight__panel__body--content">
                      <p></p>
                      <p>
                        {{ flight.departure_date }} <br />
                        Duração: {{ flight.departure_duration }}
                        <span v-if="flight.departure_range">
                          <br />
                          {{ flight.departure_range }} <br />
                          Duração: {{ flight.departure_duration_range }} <br />
                          <strong>{{ flight.departure_total }}</strong>
                        </span>
                      </p>
                      <br />
                      <p>
                        {{ flight.return_date }} <br />
                        Duração: {{ flight.return_duration }}
                        <span v-if="flight.return_range">
                          <br />
                          {{ flight.return_range }} <br />
                          Duração: {{ flight.return_duration_range }} <br />
                          <strong>{{ flight.return_total }}</strong>
                        </span>
                      </p>
                      <p>
                        Linha aérea: <strong>{{ flight.company }}</strong> |
                        Voos:
                        <strong
                          >{{ flight.departure_flight }} -
                          {{ flight.return_flight }}
                        </strong>
                        | Classe: <strong>econômica</strong>
                      </p>
                    </div>
                  </div>
                  <hr style="border-top: 2px solid #eeeeee" />
                </div>
              </div>
              <div v-for="(flight, i) in flights" :key="`flight${i}`">
                <div class="book-flight__panel" v-if="!flight.company">
                  <div class="book-flight__panel__heading">
                    <div class="book-flight__panel__heading--selection">
                      <input
                        type="radio"
                        :id="'selectFlight' + flight.id"
                        @input="$v.whichFlight.$touch()"
                        :value="flight.id"
                        v-model="selectedFlight[j].flight"
                      />
                      <label :for="'selectFlight' + flight.id">
                        <i class="fa fa-plane"></i>&nbsp;&nbsp; Opção
                        {{ flight.id }} -
                        <strong>{{ flight.city }}</strong>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-12">
          <div class="checkbox needsChangeDate">
            <input
              type="checkbox"
              id="needsChangeDate"
              v-model="needsChangeDate"
            />
            <label for="needsChangeDate">
              <small
                >Você deseja realizar alteração de data de retorno e/ou
                adicionar trechos nesse voo mediante disponibilidade e custo
                adicional? (Não válido para datas oficiais)</small
              >
            </label>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-12 col-sm-6" v-if="!firstInfo">
      <div class="checkbox" style="margin: 15px">
        <input type="checkbox" id="confirmation" v-model="confirmation" />
        <label for="confirmation"
          ><small
            ><strong
              >Estou de acordo com os voos escolhidos e com as regras para
              alterações enviadas nos comunicados e ciente de que ao finalizar a
              inscrição não será mais possível fazer nenhuma alteração na opção
              de voo escolhida.
            </strong></small
          ></label
        >
      </div>
    </div>
    <div class="action-buttons" v-if="!firstInfo">
      <custom-button
        @clicked="
          firstInfo = true;
          scrollOnTop();
        "
        myText="Voltar"
        icon="chevron-left"
        pos="left"
      >
      </custom-button>
      <custom-button
        :disabled="$v.whichFlight.$error"
        @clicked="checkFlight"
        myText="Próximo"
        icon="chevron-right"
        pos="right"
      >
      </custom-button>
    </div>
  </div>
</template>

<script>
import { mixin } from "../../mixin.js";
import Infos from "../Infos.vue";
import CustomButtom from "../shared/CustomButton.vue";
export default {
  props: {
    loading: {
      type: Boolean,
      required: true,
    },
    flights: {
      type: Array,
      required: true,
    },
    $v: {
      type: Object,
      required: true,
    },
    whichFlight: {
      required: true,
    },
    changeDate: {
      required: true,
    },
    confirmInfo: {
      required: true,
    },
    account: {
      required: true,
    },
    participantRank: {
      required: true,
    }
  },
  components: {
    Infos,
    "custom-button": CustomButtom,
  },
  mixins: [mixin],
  data: function () {
    return {
      isLoading: this.loading,
      needsChangeDate: this.changeDate,
      selectedFlight: this.whichFlight,
      confirmation: this.confirmInfo,
      firstInfo: true,
    };
  },
  methods: {
    nextInfo: function () {
      this.firstInfo = false;
      this.scrollOnTop();
    },
    back: function () {
      this.$emit("changeTab", "Acompanhantes");
      this.scrollOnTop();
    },
    checkFlight: function () {
      this.scrollOnTop();
      if (this.$v.whichFlight.$invalid === true) {
        this.$emit("handleModal", "Info", "Selecione um voo", "info");
        return;
      }

      for (const item of this.selectedFlight) {
        if (item.flight === null && !item.passanger.isExtra) {
          this.$emit(
            "handleModal",
            "Atenção",
            "É necessário seleciona um voo para cada participante."
          );
          return;
        }
      }
      if (this.confirmInfo === false) {
        this.$emit(
          "handleModal",
          "Atenção",
          "É necessário confirmar que está de acordo com a seleção de voos."
        );
        return;
      }

      // if (this.confirmInfo === false) {
      //   this.$emit(
      //     "handleModal",
      //     "Atenção",
      //     "É necessário confirmar que as informações fornecidas são verdadeiras para efetuar o cadastro."
      //   );
      //   return;
      // }

      this.isLoading = true;
      // update flights availables
      this.$http.get(`sync`).then((response) => {
        this.$emit("handleFlights", response.data.flights);
      });
      this.$http
        .post(`flights/check`, {
          flight: this.selectedFlight,
        })
        .then(() => {
          this.$emit("handleFlightTab");
          this.isLoading = false;
        })
        .catch((err) => {
          console.error(err);
          this.$emit(
            "handleModal",
            "Limite de vagas excedido",
            // 'A quantidade de vagas no voo escolhido foi excedida. Tente selecionar um novo voo.'
            err.response.data.error.message
          );
          this.isLoading = false;
        });
    },
    flightDetail: function (id) {
      this.flights.forEach((flight) => {
        if (flight.id === id) {
          flight.display = !flight.display;
        } else {
          flight.display = false;
        }
      });
    },
    issuanceDetail: function (id) {
      this.selectedFlight = this.selectedFlight.map((issuance) => {
        if (issuance.passanger.id === id) {
          issuance.display = !issuance.display;
        } else {
          issuance.display = false;
        }
        return issuance;
      });
    },
  },
  watch: {
    isLoading: function (val) {
      this.$emit("handleLoading", val);
    },
    selectedFlight: function (val) {
      this.$emit("handleSelectedFlight", val);
    },
    whichFlight: function (val) {
      this.selectedFlight = val;
    },
    needsChangeDate: function (val) {
      this.$emit("handleChangeDate", val);
    },
    confirmation: function (val) {
      this.$emit("handleConfirmInfo", val);
    },
  },
};
</script>

<style scoped>
.title-passanger {
  border: 2px solid #334e61;
  display: flex;
  justify-content: space-between;
  cursor: pointer;
  color: rgba(0, 34, 71, 0.87);
  text-decoration: none;
  margin: 35px 0 0;
}
.title-passanger i {
  margin-top: 4px;
}

.needsChangeDate {
  padding-top: 15px;
}
</style>


// WEBPACK FOOTER //
// src/components/tabs/Flights.vue